import { render, staticRenderFns } from "./RoleManage.vue?vue&type=template&id=412e07ef&scoped=true&"
import script from "./RoleManage.vue?vue&type=script&lang=js&"
export * from "./RoleManage.vue?vue&type=script&lang=js&"
import style0 from "./RoleManage.vue?vue&type=style&index=0&id=412e07ef&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e07ef",
  null
  
)

export default component.exports